module.exports = __webpack_public_path__ + "static/media/Frame16.733ee283.png";